import PropTypes from 'prop-types';
import React from 'react';
import FooterButton from './FooterButton';
import RatingStars from './RatingStars';

var ResourceFooterLeftSide = function ResourceFooterLeftSide(_ref) {
  var licence = _ref.licence,
      owns = _ref.owns,
      licencingSchool = _ref.licencingSchool,
      noDeleteButton = _ref.noDeleteButton,
      onDeleteButtonClick = _ref.onDeleteButtonClick,
      rating = _ref.rating,
      ratingValue = _ref.ratingValue,
      onRatingStarClick = _ref.onRatingStarClick,
      onRatingLabelClick = _ref.onRatingLabelClick,
      ratingLabelText = _ref.ratingLabelText,
      ratingStarColor = _ref.ratingStarColor;

  if (!owns || licence !== 'school') {
    return /*#__PURE__*/React.createElement("span", {
      className: "dashboard-card__footer__left-side"
    }, !noDeleteButton && /*#__PURE__*/React.createElement("div", {
      className: "pull-left margin-right-md"
    }, /*#__PURE__*/React.createElement(FooterButton, {
      text: "Delete",
      onClick: onDeleteButtonClick
    })), rating && /*#__PURE__*/React.createElement(RatingStars, {
      ratingValue: ratingValue,
      onRatingStarClick: onRatingStarClick,
      onRatingLabelClick: onRatingLabelClick,
      ratingLabelText: ratingLabelText,
      ratingStarColor: ratingStarColor
    }));
  }

  var message = licencingSchool ? "Provided by ".concat(licencingSchool) : 'You have access to this resource through a school licence.';
  return /*#__PURE__*/React.createElement("span", {
    className: "dashboard-card__footer__left-side"
  }, /*#__PURE__*/React.createElement("span", {
    className: "dashboard-card__footer__school-licence__info"
  }, message));
};

ResourceFooterLeftSide.displayName = "ResourceFooterLeftSide";
ResourceFooterLeftSide.propTypes = {
  licence: PropTypes.string,
  owns: PropTypes.bool.isRequired,
  licencingSchool: PropTypes.string,
  noDeleteButton: PropTypes.bool,
  onDeleteButtonClick: PropTypes.func,
  rating: PropTypes.bool,
  ratingValue: PropTypes.number,
  onRatingStarClick: PropTypes.func,
  onRatingLabelClick: PropTypes.func,
  ratingLabelText: PropTypes.string,
  ratingStarColor: PropTypes.string
};
ResourceFooterLeftSide.defaultProps = {
  onDeleteButtonClick: function onDeleteButtonClick() {}
};
export default ResourceFooterLeftSide;